import React, { useState } from "react";
import StayUpdatedBg from "assets/Home/StayUpdated.jpg";
import { toast, Toaster } from "react-hot-toast";
import { User } from "../../../service";

const StayUpdated = ({ id }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    const trimmed = email.trim();
    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!trimmed || !emailRegex.test(trimmed)) {
      toast.error("Please enter a valid email address.");
      return;
    }

    try {
      setLoading(true);
      await User.subscribeNewsletter(trimmed);
      toast.success("You're subscribed to the newsletter!");
      setEmail("");
    } catch (err) {
      // Best effort error message
      const message =
        err?.response?.data?.message ||
        "Subscription failed. Please try again.";
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div id={id} className="relative w-full overflow-x-hidden">
      <div
        style={{
          backgroundImage: `url(${StayUpdatedBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          position: "absolute",
          top: 0,
          left: "50%",
          transform: "translateX(-50%)",
          width: "100vw",
          height: "100%",
          zIndex: 0,
        }}
      />
      <div
        style={{
          position: "absolute",
          top: 0,
          left: "50%",
          transform: "translateX(-50%)",
          width: "100vw",
          height: "100%",
          backgroundColor: "rgba(58, 65, 81, 0.8)",
          zIndex: 1,
        }}
      />
      <div className="relative z-10 w-full text-white gap-4 md:gap-8 lg:gap-[64px] xl:gap-[80px] flex flex-col px-4 lg:px-6 xl:px-8 py-8  lg:py-[64px] lg:max-w-[1440px] mx-auto">
        <div className=" flex flex-col gap-4 lg:gap-8 ">
          {/* Local toaster for this section */}
          <Toaster />
          <h1 className=" font-medium   max-w-[961px] text-[24px] md:text-[44px] leading-tight sm:leading-tight md:leading-tight lg:leading-[69px] tracking-[0]">
            Stay Updated with Properteasy
          </h1>

          <h2
            style={{ letterSpacing: "0.025em" }}
            className="  w-full   text-[18px] md:text-[22px]"
          >
            Get the latest tips on property maintenance, industry insights, and
            platform updates delivered to your inbox.
          </h2>

          <div className="flex  flex-col gap-3 w-full">
            {" "}
            <form
              onSubmit={handleSubmit}
              className="flex flex-row md:gap-4 gap-3 w-full   "
            >
              <input
                type="email"
                placeholder="    Enter your email address"
                className="text-[#242424] rounded-xl px-6 py-3  text-start max-w-[398px] w-full"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                aria-label="Email address"
                disabled={loading}
              />
              <button
                type="submit"
                disabled={loading}
                className={`bg-[#3cab5c] border border-transparent  hover:border-[#3c8f47] focus:border-[#3c8f47] focus:outline-none  w-fit hover:bg-[#3c8f47] text-white px-6 py-3 rounded-xl font-medium ${
                  loading ? "opacity-70 cursor-not-allowed" : ""
                }`}
              >
                <span className="md:hidden">
                  {loading ? "Subscribing..." : "Subscribe"}
                </span>
                <span className="hidden md:inline">
                  {loading ? "Subscribing..." : "Subscribe to our Newsletter"}
                </span>
              </button>
            </form>
            <h2
              style={{ letterSpacing: "0.025em" }}
              className="  w-full   text-[14px] md:text-[20px]"
            >
              No spam, unsubscribe at any time. We respect your privacy.
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StayUpdated;
